<template>
  <ul
    class="main-menu menuMobile"

  >
    <li class="">
      <menu-item :name="$t('menu.crm.stream')"
                 icon="fal fa-rss-square"
                 link="/task/stream"/>
    </li>
    <li class="has-sub-menu menuMobileT">
      <menu-item :name="$t('menu.operation.text')"
                 icon="fal fa-route"
                 link="/operation/dashboard"
      />
      <div class="sub-menu-w">
        <menu-header :header="$t('menu.operation.text')"/>
        <div class="sub-menu-i " >
          <sub-menu sub-menu-name="planning"/>

        </div>
      </div>
    </li>

    <li class="has-sub-menu menuMobileT">
      <menu-item :name="$t('menu.crm.text')"
                 icon="fal  fa-user-headset"
                 link="/crm/dashboard"/>
      <div class="sub-menu-w">
        <menu-header :header="$t('menu.crm.text')"/>
        <div class="sub-menu-i">
          <sub-menu sub-menu-name="CRM"/>
        </div>
      </div>
    </li>
    <li class="has-sub-menu menuMobileT">
      <menu-item :name="$t('menu.accounting.text')"
                 icon="fal fa-landmark"
                 link="/accounting/dashboard"/>
      <div class="sub-menu-w">
        <menu-header :header="$t('menu.accounting.text')"/>
        <div class="sub-menu-i">
          <sub-menu sub-menu-name="accounting"/>
        </div>
      </div>
    </li>
    <li class="has-sub-menu menuMobileT">
      <menu-item :name="$t('menu.hr.text')"
                 icon="fal fa-analytics"
                 link="/hr/dashboard"
      />
      <div class="sub-menu-w">
        <menu-header :header="$t('menu.hr.text')"/>
        <div class="sub-menu-i">
          <sub-menu sub-menu-name="HR"/>
        </div>
      </div>
    </li>
    <li class="">
      <menu-item :name="$t('menu.mail.text')"
                 icon="fal fa-mailbox"
                 link="/email"/>
    </li>
    <li class="">
      <menu-item :name="$t('menu.repports.text')"
                 icon="fal fa-file-chart-line"
                 link="/report"/>
    </li>
    <li class="">
      <menu-item :name="$t('menu.userSettings.text')"
                 icon="fal fa-users-cog"
                 link="/settings/application"/>
    </li>
    <li>
      <menu-item :name="$t('menu.settings.text')"
                 icon="fal fa-abacus"
                 link="/globalSetting"/>
    </li>
    <li class="">
      <menu-item :name="$t('menu.apps.text')"
                 icon="fal fa-box-full"
                 link="/app/dashboard"/>
    </li>

  </ul>
</template>
<script>
import MenuItem from './MenuItem'
import MenuHeader from './MenuHeader'
import SubMenu from '@/components/app/user/partials/navbar/mobile/subMenu'

export default {
	name: 'main-menu',
	components: {SubMenu, MenuItem, MenuHeader},
	data () {
		return {
			subMenuS: false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/mobile/mainMenu/index.vue